module.exports = __webpack_public_path__ + "static/ministry-9e897fd6b3cea34fb32306a3aa5ca494.jpg";